__turbopack_context__.v({
  "arrowRotated": "LocationMap-module-scss-module__4fzunq__arrowRotated",
  "breadCrumbs": "LocationMap-module-scss-module__4fzunq__breadCrumbs",
  "closed": "LocationMap-module-scss-module__4fzunq__closed",
  "mapBox": "LocationMap-module-scss-module__4fzunq__mapBox",
  "mapFilters": "LocationMap-module-scss-module__4fzunq__mapFilters",
  "mapFilters_arrow": "LocationMap-module-scss-module__4fzunq__mapFilters_arrow",
  "mapFilters_close": "LocationMap-module-scss-module__4fzunq__mapFilters_close",
  "mapFilters_list": "LocationMap-module-scss-module__4fzunq__mapFilters_list",
  "mapFilters_title": "LocationMap-module-scss-module__4fzunq__mapFilters_title",
  "mapFilters_titleBox": "LocationMap-module-scss-module__4fzunq__mapFilters_titleBox",
  "open": "LocationMap-module-scss-module__4fzunq__open",
  "opened": "LocationMap-module-scss-module__4fzunq__opened",
  "warning": "LocationMap-module-scss-module__4fzunq__warning",
  "wrapper": "LocationMap-module-scss-module__4fzunq__wrapper",
  "zoomButtons": "LocationMap-module-scss-module__4fzunq__zoomButtons",
});
